import { Button, Input, Spacer, Switch, Tooltip } from '@nextui-org/react';
import React, { Dispatch, RefObject, SetStateAction } from 'react';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { NavigateFunction } from 'react-router-dom';
import { Theme } from '../../../../contexts/ThemeContext/ThemeContext';
import { INotfisResponse } from '../../../../interfaces/response/Notfis/INotfisResponse';
import { ECargoType } from '../../hooks/useCheckOrders';
import { IPrintOrderTagModalHandle } from '../PrintOrderTagModal/PrintOrderTagModal';

export interface IPROPS {
  disableAutoSubmit: boolean;
  setDisableAutoSubmit: Dispatch<SetStateAction<boolean>>;
  submitToPrinter: (auto: boolean) => Promise<void>;
  openModalWithTag: (tag: INotfisResponse) => void;
  printModalRef: RefObject<IPrintOrderTagModalHandle>;
  theme: Theme;
  setNfKey: Dispatch<SetStateAction<string>>;
  navigate: NavigateFunction;
  nfKey: string;
  addPrintedOrder: (printedOrder: INotfisResponse) => void;
  printedOrdersArray: INotfisResponse[];
  isMobile: boolean;
  tipoCarga: ECargoType;
  setTipoCarga: Dispatch<SetStateAction<ECargoType>>;
}

const CheckEtiquetaScreen = ({
  disableAutoSubmit,
  setDisableAutoSubmit,
  submitToPrinter,
  theme,
  navigate,
  setNfKey,
  nfKey,
  printModalRef,
  addPrintedOrder,
  printedOrdersArray,
  openModalWithTag,
  isMobile,
  tipoCarga,
  setTipoCarga,
}: IPROPS): JSX.Element => {
  return (
    <div
      className={`flex ${
        isMobile ? 'flex-col-reverse gap-4' : 'flex-col gap-4'
      } flex-wrap `}
    >
      {/* Description and Switch */}
      <div
        className={`flex ${
          isMobile ? 'flex-col-reverse gap-4' : 'flex-row gap-4'
        } flex-wrap items-center justify-between `}
      >
        <div className="flex flex-row gap-2">
          {/* Description */}
          <p className={`${isMobile ? 'text-xs' : 'text-md'} text-default-800`}>
            Entre com o código da carga para imprimir a etiqueta do pedido:
          </p>

          {/* Tooltip */}
          {!isMobile && (
            <Tooltip
              hidden={isMobile}
              size={isMobile ? 'sm' : 'md'}
              className={theme}
              content={
                <div className="text-foreground-700">
                  <p className="p-2">
                    Utilize o Mozilla Firefox para que o Diálogo de Impressão
                    não apareça e estrague a experiência da Impressao Automática
                  </p>
                  <p className="p-2">
                    Para mais informações{' '}
                    <button
                      type="button"
                      className="cursor-pointer text-blue-700"
                      onClick={() => navigate('/ajuda/navegador')}
                      onKeyDown={() => navigate('/ajuda/navegador')}
                    >
                      (Clique Aqui)
                    </button>{' '}
                  </p>
                </div>
              }
            >
              <div>
                <IoMdInformationCircleOutline className="h-6 w-6 text-foreground-400" />
              </div>
            </Tooltip>
          )}
        </div>
      </div>
      <div
        className={`flex ${
          isMobile ? 'flex-col-reverse gap-4' : 'flex-row gap-4'
        } flex-wrap items-center justify-between `}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span className="text w-40 p-3 font-bold text-foreground-700">
            COLETA
          </span>
          {/* Automatic disable */}
          <Switch
            size={isMobile ? 'sm' : 'md'}
            isSelected={tipoCarga === ECargoType.Entrega}
            onValueChange={() =>
              setTipoCarga(
                tipoCarga === ECargoType.Entrega
                  ? ECargoType.Coleta
                  : ECargoType.Entrega
              )
            }
          />
          <span className="text w-40 p-3 font-bold text-foreground-700">
            ENTREGA
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* Automatic disable */}
          <Switch
            size={isMobile ? 'sm' : 'md'}
            isSelected={disableAutoSubmit}
            onValueChange={setDisableAutoSubmit}
          >
            Desabilitar conferência automática
          </Switch>
          {!isMobile && (
            <div
              style={{
                padding: '4px',
              }}
            >
              {/* Tooltip */}
              <Tooltip
                size={isMobile ? 'sm' : 'md'}
                className={theme}
                content={
                  <div className="text-foreground-700">
                    <p className="p-2">
                      Desmarque a opção de conferência automática para que o
                      sistema aguarde uma ação manual sobre a impressão da
                      etiqueta
                    </p>
                  </div>
                }
              >
                <div>
                  <IoMdInformationCircleOutline className="h-6 w-6 text-foreground-400" />
                </div>
              </Tooltip>
            </div>
          )}
        </div>
      </div>

      <Spacer y={isMobile ? 6 : 12} />

      {/* Form */}
      <form
        onSubmit={(event) => {
          event.preventDefault();
          submitToPrinter(false);
        }}
        className={`flex w-full ${
          isMobile ? 'flex-col gap-8' : 'flex-row gap-4'
        }  items-center justify-center`}
      >
        {/* Input */}
        <Input
          size="lg"
          label={isMobile ? '' : `Código da carga: `}
          variant="flat"
          maxLength={50}
          labelPlacement="outside-left"
          classNames={{
            label: 'font-bold whitespace-nowrap',
            base: 'items-center justify-center w-auto',
            mainWrapper: !isMobile ? 'w-[620px]' : 'w-[200px]',
            input: 'font-mono text-2xl text-center',
          }}
          value={nfKey}
          onValueChange={setNfKey}
          inputMode={isMobile ? 'none' : 'text'}
        />

        <Button
          type="submit"
          size="lg"
          color="primary"
          isDisabled={!disableAutoSubmit}
        >
          Imprimir
        </Button>
      </form>
      <Spacer y={12} />
    </div>
  );
};

export default CheckEtiquetaScreen;
